import React from "react";
import Icon from "../Icon";

export default props => (
  <Icon viewBox="0 0 32 32" {...props}>
    <path d="M4 4l24 24M4 28L28 4" fill="none" />
  </Icon>
);
